var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_64_329)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6168 15.9731C29.8111 15.9731 29.1565 16.6278 29.1565 17.4335C29.1565 18.2392 29.8111 18.8938 30.6168 18.8938C31.4225 18.8938 32.0772 18.2392 32.0772 17.4335C32.0772 16.6278 31.4225 15.9731 30.6168 15.9731Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1106 17.8564C20.7166 17.8564 17.957 20.616 17.957 24.01C17.957 27.4041 20.7166 30.1636 24.1106 30.1636C27.5047 30.1636 30.2642 27.4041 30.2642 24.01C30.2541 20.616 27.4946 17.8564 24.1106 17.8564ZM24.1106 27.9479C21.9352 27.9479 20.1727 26.1754 20.1727 24.01C20.1727 21.8346 21.9453 20.0721 24.1106 20.0721C26.286 20.0721 28.0485 21.8447 28.0485 24.01C28.0485 26.1754 26.276 27.9479 24.1106 27.9479Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9852 36.4984H19.0146C14.8753 36.4984 11.5115 33.1346 11.5115 28.9953V19.0246C11.5115 14.8853 14.8753 11.5215 19.0146 11.5215H28.9852C33.1246 11.5215 36.4884 14.8853 36.4884 19.0246V28.9953C36.4985 33.1245 33.1246 36.4984 28.9852 36.4984ZM19.0146 13.8681C16.1745 13.8681 13.8581 16.1845 13.8581 19.0246V28.9953C13.8581 31.8354 16.1745 34.1518 19.0146 34.1518H28.9852C31.8254 34.1518 34.1418 31.8354 34.1418 28.9953V19.0246C34.1418 16.1845 31.8254 13.8681 28.9852 13.8681H19.0146Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_329",
    x1: 7.03171,
    y1: 7.03302,
    x2: 40.9749,
    y2: 40.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0011048,
    stopColor: "#FFE185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2094,
    stopColor: "#FFBB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#FF5176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    stopColor: "#F63395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    stopColor: "#A436D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4EED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.31a4b08d824b8710e46ec2d21e2d9546.svg";
export { ForwardRef as ReactComponent };